import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { convertToMoney } from "./Money";

export class CurrencySpan extends PureComponent {
    render() {
        return (
            <ColorSpan float={this.props.float} amount={this.props.amount}>
                {convertToMoney(this.props.amount, this.props.nbDecimals)}
            </ColorSpan>
        );
    }
}

export const ColorSpan = styled.span`
    ${props => (props.amount < 0 ? "color: red;" : "")}
    float: ${props => (props.float ? props.float : "none")};
`;

CurrencySpan.defaultProps = {
    nbDecimals: 2
};

CurrencySpan.propTypes = {
    amount: PropTypes.number,
    nbDecimals: PropTypes.number,
    float: PropTypes.string
};
